module.exports = __webpack_public_path__ + "static/media/(V)_MG_6260_-_Joias_Contenporaneas.d1e95ec9.jpg";